import { signOut } from 'next-auth/react'
import { Button } from '@fluentui/react-northstar'
import { FC } from 'react'
import { useTeamsSDK } from 'use-teams-sdk'
import { useRouter } from 'next/router'
import cx from 'classnames'

interface SignOutButtonProps {
  className?: string
  'data-mobile-signout'?: string
  fluid?: boolean
}

export const SignOutButton: FC<SignOutButtonProps> = (props) => {
  const router = useRouter()
  const teamsSDKPromise = useTeamsSDK()
  const onSignOut = async () => {
    const teamsSDK = await teamsSDKPromise
    if (!teamsSDK) {
      return signOut()
    }
    try {
      await teamsSDK.authentication.authenticate({
        url: window.location.origin + '/teams_logout',
        width: 400,
        height: 400,
      })
      await router.replace(`/login?next=${router.asPath}`)
    } catch (e) {
      console.error(e)
    }
  }
  return (
    <Button
      onClick={onSignOut}
      className={props.className}
      data-mobile-signout={props['data-mobile-signout']}
      fluid={props.fluid}
      text
    >
      Sign Out
    </Button>
  )
}
